// Minimum content height for pages that sit between the website's sticky ad
// rails, so a short / filtered / no-result state can't drag the ads upward.
//
// Both rail layouts — TierListPage (src/components/TierListPage.tsx) and
// RailAdsContainer (src/components/Champions/ChampionProfile.tsx) — are the
// same flex row:
//
//     [ flex-1 min-w-0 : sticky left rail ] [ content ] [ flex-1 : right rail ]
//
// The rail columns have no height of their own; as flex items they stretch to
// the row height, which the content column sets. Filter a tier list down to a
// couple of rows and the row collapses, the rail columns collapse with it, and
// `position: sticky` has nothing left to stick against — so the ad units
// visibly drift up the page. A floor under the content keeps the row tall
// enough for the rails to hold position.
//
// Scoped to md+ because the rails only render at DESKTOP_SMALL and above;
// mobile would just get dead space. Inert in the desktop app, which positions
// its ads as Electron views rather than sticky DOM — but it lives in the
// shared containers so both shells render identically.
//
// Written as a complete literal class string (never composed from fragments)
// so Tailwind's content scanner emits the rule — same requirement as
// common/tier-card-styles.ts.
//
// This is still a stopgap: the real fix is a min-height on the rail layouts
// themselves, which would cover every page between the rails instead of the
// four that opt in here.
export const AD_RAIL_MIN_CONTENT_HEIGHT = "md:min-h-[800px]";
